import {PRODUCT} from 'constants/actions';

/**
 * Active product
 * @param {{}} state Current state
 * @param {{}} action Current action
 * @returns {*} new vlaue
 */
export default function activeProduct(
    state: boolean = false,
    action: {type: string, state: boolean},
): boolean {
    switch (action.type) {
        case PRODUCT.SET_ACTIVE_PRODUCT_ID:
            return action.payload;
        case PRODUCT.CLEAR_PRODUCT:
            return false;
        default:
            return state;
    }
}
